import * as React from "react";
import {ChangeEvent} from "react";
import {InputFieldState} from "./InputFieldState";

interface SelectProps {
    label: string;
    state: InputFieldState
    onChange?: (value: string, event: ChangeEvent<HTMLSelectElement | HTMLInputElement>, customValue?: string) => void;
    options: string[] | any;
}

interface SelectState {
    showInput: boolean,
    inputValue: string,
}

/**
 * Drop Down Select Element
 */
export class Select extends React.Component<SelectProps, SelectState> {

    public static defaultProps = {
        label: "Label"
    };

    state: SelectState = {
        showInput: false,
        inputValue: '',
    }

    componentDidMount() {
        if (this.props.options[0]) {
            this.props.onChange(this.props.options[0].key, null);
        }
    }

    componentDidUpdate(prevProps: SelectProps) {
        if (this.props.state.value !== prevProps.state.value) {
            if (typeof this.props.state.value == 'string' && this.props.state.value.indexOf('other-value') != -1) {
                this.setState({showInput: true, inputValue: this.props.state.value.substr(12)});
            } else if (this.state.showInput) {
                this.setState({showInput: false, inputValue: ''});
            }
        }
    }

    getValue() {

        if (typeof this.props.state.value == 'string' && this.props.state.value.indexOf('other-value') != -1) {
            return 'other-value';
        }

        return this.props.state.value;
    }

    render() {
        return <label className="bold"><span className="labelText">{this.props.label}</span><select
            style={{width: '100%'}}
            onChange={(event) => {
                const value = event.target.value;
                this.setState({showInput: value === 'other-value'}, () => {
                    this.props.onChange(value, event, this.state.showInput ? this.state.inputValue : '');
                });

            }} value={this.getValue()}>
            {Object.keys(this.props.options).map(key => <option key={this.props.options[key].key}
                                                                value={this.props.options[key].key}>{this.props.options[key].value}</option>)}
        </select>
            {this.state.showInput &&
                <input style={{
                    maxWidth: '100%',
                    width: '250px',
                    top: '2px',
                    position: 'relative',
                    marginLeft: '10px',
                }} className={"select-input-field react-input"} type={"text"}
                       value={this.state.inputValue}
                       onChange={(e) => {
                           this.setState({inputValue: e.target.value}, () => {
                               this.props.onChange('other-value:' + this.state.inputValue, e);
                           });
                       }
                       }/>
            }
            <div className="error_message">{this.props.state.errorMessage}</div>
        </label>
    }

}